module.exports = __webpack_public_path__ + "media/images/icon-fb-f913e6dbe017e0e7692a6e76d7b3f058.svg";